import { DeviceType } from '../api-clients/_api/config';
import { HeatingZoneID } from './zone';

export enum DataPointCommissioningCheckStatus {
  NO_DATA = 'no_data',
  NO_MAPPING = 'no_mapping',
  PASSED = 'passed',
  FAILED = 'failed',
}

export type DataPointCommissioningCheck = {
  name: string;
  status: DataPointCommissioningCheckStatus;
  value?: number;
  unit?: string;
};

export enum PeripheralHealthCheckReason {
  TIMEOUT = 'timeout',
  INVALID_DATA = 'invalid_data',
  INVALID_FUNCTION = 'invalid_function',
  INVALID_ADDRESS = 'invalid_address',
  INVALID_CONFIGURATION = 'invalid_configuration',
  UNKNOWN_ERROR = 'unknown_error',
}

export enum PeripheralHealthCheckStatus {
  FAILED = 'failed_healthcheck',
  PENDING = 'pending_healthcheck',
  PASSED = 'passed_healthcheck',
}

export type IPeripheralHealthCheck = {
  device_type: DeviceType;
  zone_id: HeatingZoneID | string;
  status: PeripheralHealthCheckStatus;
  reason: PeripheralHealthCheckReason | null;
  timestamp: string;
  data?: string;
  datapoint_checks?: DataPointCommissioningCheck[];
};
